import React, { useContext, useState } from 'react';
import { Col, Divider, Form, Radio, Row } from 'antd';
import tokens from '../../../../../../../../utils/tokens';
import DataForm from './DataForm';
import { EnrollmentFormContext } from '../../../../../../../../providers/EnrollmentFormContextProvider';
import form from '../../../../../../../../utils/form';
import ModalBeneficiaries from '../PreviewUAFForm/ModalBeneficiaries'

const FinalBeneficiariesForm = () => {
  const [hasBeneficiaries, setHasBeneficiaries] = useState(false);

  const { enrollmentForm } = useContext(EnrollmentFormContext);

  const gutter = tokens.forms.horizontalGutterInPx;

  const handleHasBeneficiariesToggle = (event) => {
    setHasBeneficiaries(event.target.value);
  };

  return (
    <Form
      form={enrollmentForm}
      layout="vertical"
      onFinishFailed={() => 'failed'}
      validateMessages={form.validateMessages}
    >
      <Row>
        <Col className="declaringPersonForm__title" span={24}>
          <ModalBeneficiaries />
        </Col>
      </Row>
      <Form.Item
        label="¿Tienen sus beneficiarios finales naturales más del 10% de propiedad?"
        rules={[
          {
            required: true,
          },
        ]}
      >
        <Radio.Group onChange={handleHasBeneficiariesToggle} value={hasBeneficiaries}>
          <Radio value>Si</Radio>
          <Radio value={false}>No</Radio>
        </Radio.Group>
      </Form.Item>
      <Divider style={{ marginTop: 0 }} />
      {hasBeneficiaries && <DataForm gutter={gutter} />}
      <p>
        Debe continuar al siguiente paso y determinar quién es el controlador persona natural de la
        empresa.
      </p>
    </Form>
  );
};

export default FinalBeneficiariesForm;
